// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.upload-dialog {
  width: 90%;
  max-width: 1200px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  z-index: 10000;
}

.selection-dialog {
  min-height: 500px;
  max-height: 90vh;
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #fff;
  color: #111827;
  border-bottom: 1px solid #e4e8f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right {
  position: relative;
  z-index: 10009;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-circle mat-icon {
  color: #5ea1d8;
  font-size: 24px;
}

.header-copy p {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.header-copy span {
  font-size: 14px;
  color: #6b7280;
}

.icon-button {
  border: none;
  background: #f3f4f6;
  color: inherit;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.icon-button mat-icon {
  font-size: 22px;
}
.icon-button:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.selection-body {
  padding: 40px 24px;
  flex: 1;
  overflow-y: auto;
}

.featured-card {
  border: 2px solid #c7d2fe;
  box-shadow: 0 12px 32px rgba(94, 161, 216, 0.15);
}

.selection-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .selection-options {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .upload-backdrop {
    padding: 0;
    align-items: flex-start;
  }
  .upload-dialog {
    width: 100% !important;
    max-width: 100% !important;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    overflow-y: auto;
  }
  .selection-dialog {
    min-height: 100vh;
  }
  .selection-body {
    padding: 20px 16px;
  }
  .selection-card {
    padding: 20px;
  }
}
.selection-card {
  background: #fff;
  border: 2px solid #e4e8f0;
  border-radius: 16px;
  padding: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  position: relative;
  overflow: visible;
  text-align: left;
}
.selection-card:hover {
  border-color: #5ea1d8;
  box-shadow: 0 8px 24px rgba(94, 161, 216, 0.15);
  transform: translateY(-2px);
}
@media (max-width: 768px) {
  .selection-card {
    padding: 24px;
  }
}

.card-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.card-icon mat-icon {
  font-size: 32px;
  color: #5ea1d8;
  width: 32px;
  height: 32px;
}

.selection-card.ai-card {
  border-color: #c7dff0;
  position: relative;
  overflow: visible;
}
.selection-card.ai-card:hover {
  border-color: #5ea1d8;
  box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2);
}

/* Top-right paid feature chip on Smart Create card */
.paid-feature-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  background-color: #e83e8c;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(232, 62, 140, 0.35);
}

.badge-action,
.coin-purchase-link {
  border: none;
  background: none;
  color: #5ea1d8;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.badge-action,
.coin-purchase-link {
  align-self: center;
  margin-top: -0.25rem;
}

.card-icon.ai-icon {
  background: linear-gradient(135deg, #eef6fc 0%, #dceefb 100%);
}

.select-button.ai-button {
  background: linear-gradient(135deg, #5ea1d8 0%, #4a8bc4 100%);
}

.selection-card h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}

.selection-card p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #374151;
}
.feature-item mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #16a34a;
}

.select-button {
  margin-top: auto;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}
.select-button.primary {
  background: #5ea1d8;
  color: white;
}
.select-button.primary:hover {
  background: #4a8fc4;
}
.select-button.secondary {
  background: #f3f4f6;
  color: #111827;
}
.select-button.secondary:hover {
  background: #e5e7eb;
}

:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-header {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-header .header-copy p {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-header .header-copy span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .icon-circle {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .icon-circle mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .icon-button {
  background: #1f2937 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .icon-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .selection-body {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .selection-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .selection-card:hover {
  border-color: #5ea1d8 !important;
  box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2) !important;
}
:host-context(body.theme-dark) .selection-card h3 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .selection-card p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .card-icon {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .card-icon mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .feature-item {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .feature-item mat-icon {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .select-button.primary {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .select-button.primary:hover {
  background: #4a8fc4 !important;
}
:host-context(body.theme-dark) .select-button.secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .select-button.secondary:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .paid-feature-badge {
  background-color: #e83e8c !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/create-flow-selection/create-flow-selection.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;AACJ;;AAIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,eAAA;EACA,cAAA;AAFJ;;AAMA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AAHF;AAKE;EACE,eAAA;AAHJ;AAME;EACE,mBAAA;EACA,2BAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,OAAA;EACA,gBAAA;AALF;;AAQA;EACE,yBAAA;EACA,gDAAA;AALF;;AAQA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AALF;AAOE;EAPF;IAQI,0BAAA;IACA,SAAA;EAJF;AACF;;AAOA;EACE;IACE,UAAA;IACA,uBAAA;EAJF;EAOA;IACE,sBAAA;IACA,0BAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EALF;EAQA;IACE,iBAAA;EANF;EASA;IACE,kBAAA;EAPF;EAUA;IACE,aAAA;EARF;AACF;AAWA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AATF;AAWE;EACE,qBAAA;EACA,+CAAA;EACA,2BAAA;AATJ;AAYE;EArBF;IAsBI,aAAA;EATF;AACF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AATF;AAWE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AATJ;;AAaA;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;AAVF;AAYE;EACE,qBAAA;EACA,8CAAA;AAVJ;;AAcA,qDAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,8CAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;AAXF;;AAcA;;EAEE,kBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,6DAAA;AAXF;;AAcA;EACE,6DAAA;AAXF;;AAcA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAXF;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAXJ;;AAeA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AAZF;AAcE;EACE,mBAAA;EACA,YAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAgBE;EACE,mBAAA;EACA,cAAA;AAdJ;AAgBI;EACE,mBAAA;AAdN;;AAoBE;EACE,8BAAA;EACA,yBAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,yBAAA;EACA,yDAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;AAqBI;EACE,yBAAA;AAnBN;AAuBE;EACE,8BAAA;AArBJ;AAuBI;EACE,yBAAA;AArBN;AAyBE;EACE,8BAAA;EACA,yBAAA;AAvBJ;AAyBI;EACE,8BAAA;AAvBN;AA2BE;EACE,8BAAA;AAzBJ;AA4BE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA1BJ;AA4BI;EACE,gCAAA;EACA,yDAAA;AA1BN;AA6BI;EACE,yBAAA;AA3BN;AA8BI;EACE,yBAAA;AA5BN;AAgCE;EACE,8BAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;AAkCE;EACE,yBAAA;AAhCJ;AAkCI;EACE,yBAAA;AAhCN;AAqCI;EACE,8BAAA;EACA,yBAAA;AAnCN;AAqCM;EACE,8BAAA;AAnCR;AAuCI;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AArCN;AAuCM;EACE,8BAAA;AArCR;AA0CE;EACE,oCAAA;EACA,yBAAA;AAxCJ","sourcesContent":[".upload-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n.upload-dialog {\n  width: 90%;\n  max-width: 1200px;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: auto;\n  z-index: 10000;\n}\n\n.selection-dialog {\n  min-height: 500px;\n  max-height: 90vh;\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: #fff;\n  color: #111827;\n  border-bottom: 1px solid #e4e8f0;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-right {\n  position: relative;\n  z-index: 10009;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  mat-icon {\n    color: #5ea1d8;\n    font-size: 24px;\n  }\n}\n\n.header-copy {\n  p {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  color: inherit;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n\n  mat-icon {\n    font-size: 22px;\n  }\n\n  &:hover {\n    background: #e5e7eb;\n    transform: translateY(-1px);\n  }\n}\n\n.selection-body {\n  padding: 40px 24px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.featured-card {\n  border: 2px solid #c7d2fe;\n  box-shadow: 0 12px 32px rgba(94, 161, 216, 0.15);\n}\n\n.selection-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .upload-backdrop {\n    padding: 0;\n    align-items: flex-start;\n  }\n\n  .upload-dialog {\n    width: 100% !important;\n    max-width: 100% !important;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n    overflow-y: auto;\n  }\n\n  .selection-dialog {\n    min-height: 100vh;\n  }\n\n  .selection-body {\n    padding: 20px 16px;\n  }\n\n  .selection-card {\n    padding: 20px;\n  }\n}\n\n.selection-card {\n  background: #fff;\n  border: 2px solid #e4e8f0;\n  border-radius: 16px;\n  padding: 32px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 16px;\n  position: relative;\n  overflow: visible;\n  text-align: left;\n\n  &:hover {\n    border-color: #5ea1d8;\n    box-shadow: 0 8px 24px rgba(94, 161, 216, 0.15);\n    transform: translateY(-2px);\n  }\n\n  @media (max-width: 768px) {\n    padding: 24px;\n  }\n}\n\n.card-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 12px;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n  flex-shrink: 0;\n\n  mat-icon {\n    font-size: 32px;\n    color: #5ea1d8;\n    width: 32px;\n    height: 32px;\n  }\n}\n\n.selection-card.ai-card {\n  border-color: #c7dff0;\n  position: relative;\n  overflow: visible;\n\n  &:hover {\n    border-color: #5ea1d8;\n    box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2);\n  }\n}\n\n/* Top-right paid feature chip on Smart Create card */\n.paid-feature-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background-color: #e83e8c;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1;\n  white-space: nowrap;\n  pointer-events: none;\n  box-shadow: 0 2px 8px rgba(232, 62, 140, 0.35);\n}\n\n.badge-action,\n.coin-purchase-link {\n  border: none;\n  background: none;\n  color: #5ea1d8;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.badge-action,\n.coin-purchase-link {\n  align-self: center;\n  margin-top: -0.25rem;\n}\n\n.card-icon.ai-icon {\n  background: linear-gradient(135deg, #eef6fc 0%, #dceefb 100%);\n}\n\n.select-button.ai-button {\n  background: linear-gradient(135deg, #5ea1d8 0%, #4a8bc4 100%);\n}\n\n.selection-card h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.selection-card p {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n.card-features {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #374151;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #16a34a;\n  }\n}\n\n.select-button {\n  margin-top: auto;\n  padding: 12px 24px;\n  border-radius: 8px;\n  border: none;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n\n  &.primary {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover {\n      background: #4a8fc4;\n    }\n  }\n\n  &.secondary {\n    background: #f3f4f6;\n    color: #111827;\n\n    &:hover {\n      background: #e5e7eb;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .upload-dialog {\n    background: #0f172a !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-header {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n    .header-copy p {\n      color: #f3f4f6 !important;\n    }\n\n    .header-copy span {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .icon-circle {\n    background: #1f2937 !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .icon-button {\n    background: #1f2937 !important;\n    color: #f3f4f6 !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  .selection-body {\n    background: #0f172a !important;\n  }\n\n  .selection-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    color: #f3f4f6 !important;\n\n    &:hover {\n      border-color: #5ea1d8 !important;\n      box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2) !important;\n    }\n\n    h3 {\n      color: #f3f4f6 !important;\n    }\n\n    p {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .card-icon {\n    background: #1e293b !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .feature-item {\n    color: #cbd5e1 !important;\n\n    mat-icon {\n      color: #4ade80 !important;\n    }\n  }\n\n  .select-button {\n    &.primary {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n\n      &:hover {\n        background: #4a8fc4 !important;\n      }\n    }\n\n    &.secondary {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border: 1px solid rgba(148, 163, 184, 0.35) !important;\n\n      &:hover {\n        background: #334155 !important;\n      }\n    }\n  }\n\n  .paid-feature-badge {\n    background-color: #e83e8c !important;\n    color: #ffffff !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
